import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Breadcrumb, { BreadcrumbItem } from '../../commons/Breadcrumb';
import { FaHome } from '@react-icons/all-files/fa/FaHome';
import { FaConciergeBell } from '@react-icons/all-files/fa/FaConciergeBell';
import { useAppSelector } from '../../store';

function CompaniasBreadcrumb() {
  const location = useLocation();
  const entities = useAppSelector(state => state.proveedor.entities) as { id?: number; nombre?: string }[];

  const items: BreadcrumbItem[] = [
    { label: 'Inicio', to: '/', icon: <FaHome /> },
    { label: 'Compañías & Servicios', to: '/companias', icon: <FaConciergeBell /> },
  ];

  const match = location.pathname.match(/\/companias\/(\d+)/);
  const companiaId = match?.[1];

  if (companiaId) {
    const compania = entities?.find(e => String(e.id) === String(companiaId));
    const label = compania?.nombre ?? `Compañía ${companiaId}`;
    items.push({ label, icon: <FaConciergeBell /> });
  }

  return <Breadcrumb items={items} />;
}

function CompaniasLayout() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <CompaniasBreadcrumb />
      <Outlet />
    </div>
  );
}

export default CompaniasLayout;
